var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawalDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_46_3987)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_46_3987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.10397 16.1846C6.29868 14.8324 6.29868 13.1676 7.10397 11.8154L11.3463 4.69169C12.1538 3.33566 13.6484 2.5 15.2661 2.5L23.7339 2.5C25.3516 2.5 26.8462 3.33566 27.6537 4.69169L31.896 11.8154C32.7013 13.1676 32.7013 14.8324 31.896 16.1846L27.6537 23.3083C26.8462 24.6643 25.3516 25.5 23.7339 25.5L15.2661 25.5C13.6484 25.5 12.1538 24.6643 11.3463 23.3083L7.10397 16.1846Z",
    fill: "#19191E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8335 12.1666H26.1668V10.9666C26.1668 10.2199 26.1668 9.84654 26.0215 9.56133C25.8937 9.31044 25.6897 9.10647 25.4388 8.97864C25.1536 8.83331 24.7802 8.83331 24.0335 8.83331H14.9668C14.2201 8.83331 13.8467 8.83331 13.5615 8.97864C13.3106 9.10647 13.1067 9.31044 12.9788 9.56133C12.8335 9.84654 12.8335 10.2199 12.8335 10.9666V12.1666Z",
    fill: "#E9BE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1668 17.5L24.1668 19.5M24.1668 19.5L26.1668 17.5M24.1668 19.5V15.5M26.1668 12.1666H12.8335M26.1668 13.5V10.9666C26.1668 10.2199 26.1668 9.84654 26.0215 9.56133C25.8937 9.31044 25.6897 9.10647 25.4388 8.97864C25.1536 8.83331 24.7802 8.83331 24.0335 8.83331H14.9668C14.2201 8.83331 13.8467 8.83331 13.5615 8.97864C13.3106 9.10647 13.1067 9.31044 12.9788 9.56133C12.8335 9.84654 12.8335 10.2199 12.8335 10.9666V16.0333C12.8335 16.78 12.8335 17.1534 12.9788 17.4386C13.1067 17.6895 13.3106 17.8935 13.5615 18.0213C13.8467 18.1666 14.2201 18.1666 14.9668 18.1666H19.5002",
    stroke: "#E9BE5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_46_3987",
    x: 0.513388,
    y: 0.0349245,
    width: 38.6775,
    height: 35.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.23254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_46_3987"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.352154,
    dy: 4.04977
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.16938
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_46_3987",
    result: "effect2_dropShadow_46_3987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_46_3987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_46_3987",
    x: 4.3185,
    y: 0.318499,
    width: 30.363,
    height: 27.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.09075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_46_3987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_46_3987",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.335615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167808
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_46_3987"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_46_3987",
    result: "effect3_innerShadow_46_3987"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalDark);
export default __webpack_public_path__ + "static/media/withdrawal-dark.f6ba46288b2c51922077c6cdabf312ba.svg";
export { ForwardRef as ReactComponent };